export const vicSubmissionConfirmPopup = {
  title: 'Submit VIC?',
  description:
    'Please note that comments in the Consolidated Cost Component and BOM Level View will be submitted. Once submitted, no further changes can be made.',
  confirmationText: 'Submit',
};

export const MAX_ATTACHMENTS = 5;
